module.exports = __webpack_public_path__ + "img/course_bg3.bc45f368.png";